import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { AddSimpanComponent } from 'src/app/Reserve/add-simpan/add-simpan.component';
import { ReceiptDetailsComponent } from 'src/app/Sets/receipt-details/receipt-details.component';
import { ConfirmationDialogComponent } from 'src/app/Shared/confirmation-dialog/confirmation-dialog.component';
import { Enums } from 'src/app/Shared/enums';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { ALERT_TYPE } from 'src/app/constants';
import { Account } from 'src/model/account.model';
import { Loan } from 'src/model/loan.model';

@Component({
    selector: 'app-loan-reserve',
    templateUrl: './loan-reserve.component.html',
    styleUrls: ['./loan-reserve.component.scss'],
    standalone: false
})
export class LoanReserveComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  private restApi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);
  protected enums = inject(Enums);
  protected sharedService = inject(SharedService);

  @Input() selectedLoan: Loan;
  @Input() paymentAmount: number;

  //reserveOption
  reserveOption: number;

  //2 way binding vars
  principalAmount = 0;
  duitLebihAmount = 0;
  // interestChargeAmount: number = 0;
  interestChargeAmount = 0;

  companyAccountList: Account[] = [];
  selectedAccountId: number;
  stampAmount = 0;
  scAmount = 0;
  loggedInCompanyId: number;

  isPayPrincipal = false;
  isReserveNegative = false;

  paymentDate: Date = new Date();
  @Output() passEntry = new EventEmitter<any>();

  isDirty = false;

  disabledSubmit = false;

  ngOnInit(): void {
    this.loggedInCompanyId = Number(sessionStorage.getItem('companyId'));
    this.getAllAccountsOfCompany(this.loggedInCompanyId);

    if (this.selectedLoan.Status == this.enums.SETTLED_LOAN)
      this.reserveOption = this.enums.WITHDRAW_INTEREST_CHARGE;

    else if (this.selectedLoan.Scheme == "HUTANG")
      this.reserveOption = this.enums.PAY_PRINCIPAL;

    else
      this.reserveOption = this.enums.PAY_MONTHLY;
    // this.calculateStampAndServiceCharge(this.paymentAmount);
  }

  isCP(loanStatus: number) {
    if (Number(loanStatus) == Number(this.enums.CP_LOAN))
      return true;
    else
      return false;
  }

  changeReserveOption(option: number) {
    this.reserveOption = option;
    this.stampAmount = 0;
    this.scAmount = 0;
    this.duitLebihAmount = 0;
  }

  topUpSimpan() {
    const modalRef = this.sharedService.openModal(AddSimpanComponent);
    modalRef.componentInstance.isModal = true;
    modalRef.componentInstance.selectedProfileID = this.selectedLoan.ProfileId;

    modalRef.componentInstance.passEntry.subscribe((entry) => {
      const addedSimpan = entry;

      this.selectedLoan.Reserve += addedSimpan;
      this.isDirty = true;
    });
  }

  isSchemeA() {
    if (this.selectedLoan.Scheme == "A")
      return true;
    else
      return false;
  }

  setActive(type: string) {
    if (this.selectedLoan.Status == this.enums.SETTLED_LOAN) {
      if (type == 'InterestCharge') {
        return 'active';
      }
      else
        return ''
    }
    else if (this.selectedLoan.Scheme == "HUTANG") {
      if (type == 'Principal') {
        return 'active';
      }
      else
        return ''
    } else {
      if (type == 'Monthly') {
        return 'active';
      }

      else
        return ''
    }
  }

  private getAllAccountsOfCompany(companyId: number) {
    const xhttp = this.restApi.getRequest(this.constructApi.getAccountsOfCompany(companyId));
    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        const jsonArray = JSON.parse((xhttp.responseText));

        jsonArray.forEach(json => {
          const account = new Account(json.id, json.number, json.name, json.holderName, json.balance, json.companyId, json.username);
          const loggedInUser = sessionStorage.getItem("username");
          this.companyAccountList.push(account);
        });
      }
    };
  }

  setIsPayPrincipal(principal: boolean) {
    this.isPayPrincipal = principal;
    if (principal == true)
      this.reserveOption = this.enums.PAY_PRINCIPAL
    else
      this.reserveOption = this.enums.PAY_MONTHLY
  }

  setSelectedAccount(accountId: number) {
    if (accountId === this.selectedAccountId)
      return true
    else
      return false;
  }

  // getDefaultMonthlyPayment() {
  //   var defaultMonthly = 0;

  //   if (this.selectedLoan.Scheme == 'A') {
  //     defaultMonthly = this.selectedLoan.InterestRate / 100 * this.selectedLoan.Principal;
  //   } else {
  //     defaultMonthly = this.selectedLoan.InterestRate / 100 * this.selectedLoan.Principal + (this.selectedLoan.Principal / this.selectedLoan.Term);
  //   }

  //   return this.roundTo2Dec(defaultMonthly);

  // }

  roundTo2Dec(num: number) {
    return Math.round(num * 100) / 100
  }

  assignPrincipalAndCharges(assignAmount: number) {
    this.principalAmount = assignAmount;
    //REMEMBER TO ADD THIS BACK
    // this.calculateStampAndServiceCharge(this.principalAmount);
  }

  calculateStampAndServiceCharge(amount: number) {
    if (this.selectedLoan.Scheme == "A") {
      if (amount > 2000) {
        this.stampAmount = 20;
        this.scAmount = 6
      }
      else if (amount > 500) {
        this.stampAmount = 10;
        this.scAmount = 3;
      } else if (amount >= 50) {
        this.stampAmount = 3;
        this.scAmount = 5;
      }
      else {
        this.stampAmount = 0;
        this.scAmount = 0;
      }
    } else if (this.selectedLoan.Scheme == "P") {
      this.stampAmount = 20;
      this.scAmount = 6;
    } else {
      this.stampAmount = 10;
      this.scAmount = 0;
    }
  }

  checkPaymentFieldValid() {
    let errorMsg = "";

    if (this.selectedAccountId == undefined) {
      errorMsg += "Please select account!\n"
    }

    if (this.reserveOption != this.enums.WITHDRAW_INTEREST_CHARGE) {
      //STAMP AND SC LIMIT ONLY RESTRICT NON CP LOAN
      if (this.selectedLoan.Status != this.enums.CP_LOAN) {
        if (this.stampAmount > this.enums.MAXIMUM_STAMP_NORMAL_SCHEME)
          errorMsg += "Stamp Amount cannot more than " + this.enums.MAXIMUM_STAMP_NORMAL_SCHEME + "!\n"

        if (this.scAmount > this.enums.MAXIMUM_SC_NORMAL_SCHEME)
          errorMsg += "SC Amount cannot more than " + this.enums.MAXIMUM_SC_NORMAL_SCHEME + "!\n"
      }

      if (this.reserveOption == this.enums.PAY_MONTHLY) {
        if (this.stampAmount + this.scAmount + this.duitLebihAmount + this.paymentAmount > this.selectedLoan.Reserve) {
          errorMsg += "Payment amount more than simpan amount!\n"
        }
      }

      else if (this.reserveOption == this.enums.PAY_PRINCIPAL) {
        if (this.stampAmount + this.scAmount + this.duitLebihAmount + this.principalAmount > this.selectedLoan.Reserve) {
          errorMsg += "Payment amount more than simpan amount!\n"
        } else if (this.principalAmount == 0 || this.principalAmount == undefined) {
          errorMsg += "Please fill in your principal amount!\n";
        }

        else if (this.principalAmount > this.selectedLoan.Balance)
          errorMsg += "Payment amount more than loan balance!\n";
      }
    }
    else {
      if (this.interestChargeAmount == undefined || this.interestChargeAmount == 0)
        errorMsg += "Please fill in your interest charge amount!\n";

      //STAMP AND SC LIMIT ONLY RESTRICT NON CP LOAN
      if (this.selectedLoan.Status != this.enums.CP_LOAN) {
        // make sure total charges not more than interest charge
        if (this.stampAmount + this.scAmount >= this.interestChargeAmount) {
          errorMsg += "Stamp + SC Charge cannot more than Interest Charge amount!\n"
        }
        else {
          // if total charges lesser than interest charge
          // make sure total charges follow defined ratio of charges
          const stampRatio = this.enums.MINIMUM_STAMP / (this.enums.MINIMUM_STAMP + this.enums.MINIMUM_SC);
          const scRatio = this.enums.MINIMUM_SC / (this.enums.MINIMUM_STAMP + this.enums.MINIMUM_SC);
          const totalCharge = this.stampAmount + this.scAmount;

          if (this.stampAmount > totalCharge * stampRatio)
            errorMsg += "Stamp Amount cannot more than RM" + this.sharedService.roundTo2Dec(totalCharge * stampRatio) + "!\n"
          if (this.scAmount > totalCharge * scRatio)
            errorMsg += "SC Amount cannot more than RM " + this.sharedService.roundTo2Dec(totalCharge * scRatio) + "!\n"
        }
      }
    }

    return errorMsg;
  }

  checkSimpanLeftEnough() {
    switch (this.reserveOption) {
      case this.enums.PAY_MONTHLY:
        if (this.sharedService.roundTo2Dec(this.calculateReserveLeft(this.paymentAmount)) < 0)
          return false;
        break;
      case this.enums.PAY_PRINCIPAL:
        if (this.sharedService.roundTo2Dec(this.calculateReserveLeft(this.principalAmount)) < 0)
          return false;
        break;
      case this.enums.WITHDRAW_INTEREST_CHARGE:
        if (this.sharedService.roundTo2Dec(this.calculateReserveLeft(this.interestChargeAmount)) < 0)
          return false;
        break;
    }
    return true;
  }

  checkPrincipalEmpty() {
    if (this.principalAmount == 0 || this.principalAmount == undefined) {
      this.stampAmount = 0;
      this.scAmount = 0;
      this.duitLebihAmount = 0;
    }
  }

  checkInterstChargeEmpty() {
    if (this.interestChargeAmount == 0 || this.interestChargeAmount == undefined) {
      this.stampAmount = 0;
      this.scAmount = 0;
    }
  }

  submit() {
    const errorMsg = this.checkPaymentFieldValid();

    if (errorMsg == "") {
      if (this.reserveOption == this.enums.PAY_PRINCIPAL || this.reserveOption == this.enums.PAY_MONTHLY)
        this.payWithReserve();

      else if (this.reserveOption == this.enums.WITHDRAW_INTEREST_CHARGE) {
        //if loan is still NOT SETTLED,and interest charge entered is more than loan monthly interest amount, need remind user
        // make sure remind user to do monthly payment first if got sufficient money instead of straight pay interest charge

        if (this.selectedLoan.Status != this.enums.SETTLED_LOAN && this.interestChargeAmount >= this.selectedLoan.Principal * (this.selectedLoan.InterestRate / 100)) {
          const modalRef = this.sharedService.openModal(ConfirmationDialogComponent, "regularModal");
          modalRef.componentInstance.message = "Interest Charge amount is more than monthly interest amount! Please make sure monthly interest paid before paying interest charge! Continue payment?"
          modalRef.result.then((confirm) => {
            if (confirm)
              this.withdrawInterestChargeWithReserve();
          });
        }
        else
          this.withdrawInterestChargeWithReserve();
      }
    } else
      this.sharedService.openAlert(errorMsg, ALERT_TYPE.DANGER);
  }

  calculateReserveLeft(amount: number) {
    return this.selectedLoan.Reserve - amount - this.stampAmount - this.scAmount - this.duitLebihAmount;
  }

  withdrawInterestChargeWithReserve() {
    this.disabledSubmit = true;
    const data = {
      "accountId": Number(this.selectedAccountId),
      "dateCreated": this.paymentDate,
      "extraInterest": this.interestChargeAmount,
      "stamp": this.stampAmount,
      "serviceCharge": this.scAmount,
      "remark": "Interest Charge with Simpan=Loan " + this.selectedLoan.LoanCode
    };

    const xhr = this.restApi.postRequest(this.constructApi.getAddReserveWithdrawal(this.selectedLoan.ID), data);
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        this.disabledSubmit = false;
        if (xhr.status == 200) {
          this.sharedService.openAlert("Successfully withdraw interest charge with reserve!", ALERT_TYPE.SUCCESS);

          if (this.selectedLoan.Scheme == 'EPF' || this.selectedLoan.IsEPF == true) {
            const json = JSON.parse(xhr.responseText);
            const addedTransactionId = Number(json.id);
            this.addExtraInterestSet([addedTransactionId]);
          }
          else {
            this.passEntry.emit(this.selectedLoan.ID);
            this.reset();
          }
        } else
          this.sharedService.openErrorMessage(xhr);
      }
    }
  }

  addExtraInterestSet(idsToAdd: number[]) {
    this.disabledSubmit = true;

    const companyId = Number(sessionStorage.getItem("companyId"))
    const data = {
      "transactionIds": idsToAdd,
      "remark": "INTEREST CHARGE USING SIMPAN",
      "name": "EPF CUSTOMER INTEREST CHARGE"
    }

    const xhr = this.restApi.postRequest(this.constructApi.getAddNewCompanySet(companyId), data);
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        this.disabledSubmit = false;

        if (xhr.status == 200) {
          var json = JSON.parse(xhr.responseText);
          const addedSetId = Number(json.id);

          this.activeModal.close();
          const modalRef = this.sharedService.openModal(ReceiptDetailsComponent, "largeModal");
          modalRef.componentInstance.receiptId = Number(addedSetId);
          modalRef.componentInstance.isModal = true;
          modalRef.componentInstance.passEntry.subscribe((entry) => {
            window.location.reload();
          });
        }
        else {
          var json = JSON.parse(xhr.responseText);
          this.sharedService.openAlert(json.error, ALERT_TYPE.DANGER)
        }
      }
    }
  }

  payOnlySCAndServiceCharge() {
    const data = {
      "term": 0,
      "accountId": Number(this.selectedAccountId),
      "dateCreated": new Date(),
      "reserve": - this.stampAmount - this.scAmount,
      "stamp": this.stampAmount,
      "serviceCharge": this.scAmount,
      "remark": "Pay with Simpan=Loan " + this.selectedLoan.LoanCode
    };

    const xhr = this.restApi.postRequest(this.constructApi.getAddPaymentWithReserve(this.selectedLoan.ID), data);
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        if (xhr.status == 200) {
          this.disabledSubmit = false;
          this.passEntry.emit(this.selectedLoan.ID)
          this.reset();
          this.sharedService.openAlert("Successfully withdraw interest charge with reserve!", ALERT_TYPE.SUCCESS);
        }
        else {
          this.disabledSubmit = false;
          this.sharedService.openAlert("Opps,some error occured. Please try again later", ALERT_TYPE.DANGER);
        }
      }
    }
  }
  payWithReserve() {
    this.disabledSubmit = true;

    let data;
    let extras;
    if (this.duitLebihAmount > 0) {
      extras = [{ "amount": this.duitLebihAmount }];
    }

    // if (this.isSchemeA()) {
    if (this.isPayPrincipal && this.isSchemeA()) {
      data = {
        "principal": this.principalAmount,
        "accountId": Number(this.selectedAccountId),
        "stamp": this.stampAmount,
        "serviceCharge": this.scAmount,
        "extras": extras,
        "dateCreated": this.paymentDate,
        "reserve": -this.principalAmount - this.stampAmount - this.scAmount - this.duitLebihAmount,
        "remark": "Pay Principal with Simpan=Loan " + this.selectedLoan.LoanCode
      };
    }
    // else {
    //   data = {
    //     "interestCharge": this.paymentAmount,
    //     "accountId": Number(this.selectedAccountId),
    //     "stamp": this.stampAmount,
    //     "serviceCharge": this.scAmount,
    //     "extras": extras,
    //     "dateCreated": this.paymentDate,
    //     "reserve": -this.paymentAmount - this.stampAmount - this.scAmount - this.duitLebihAmount,
    //     "remark": "Pay with Simpan=Loan " + this.selectedLoan.LoanCode

    //   };
    // }

    // }
    else {
      const term = (this.selectedLoan.Scheme == "HUTANG") ? (this.principalAmount / this.selectedLoan.Balance) : 1;
      data = {
        "term": term,
        "accountId": Number(this.selectedAccountId),
        "dateCreated": this.paymentDate,
        "reserve": -this.paymentAmount - this.stampAmount - this.scAmount,
        "stamp": this.stampAmount,
        "extras": extras,
        "serviceCharge": this.scAmount,
        "remark": "Pay with Simpan=Loan " + this.selectedLoan.LoanCode
      };
    }
    const xhr = this.restApi.postRequest(this.constructApi.getAddPaymentWithReserve(this.selectedLoan.ID), data);
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        if (xhr.status == 200) {
          this.disabledSubmit = false;
          this.passEntry.emit(this.selectedLoan.ID)
          this.reset();
          this.sharedService.openAlert("Successfully made payment!", ALERT_TYPE.SUCCESS);
        }
        else {
          this.disabledSubmit = false;
          this.sharedService.openAlert("Opps,some error occured. Please try again later", ALERT_TYPE.DANGER);
        }
      }
    }
  }
  reset() {
    if (this.isDirty == true)
      window.location.reload();
    else
      this.activeModal.close();
  }
}
